import { render, staticRenderFns } from "./ConsignatariaForm.vue?vue&type=template&id=498852b4&scoped=true&"
import script from "./ConsignatariaForm.vue?vue&type=script&lang=js&"
export * from "./ConsignatariaForm.vue?vue&type=script&lang=js&"
import style0 from "./ConsignatariaForm.vue?vue&type=style&index=0&id=498852b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498852b4",
  null
  
)

export default component.exports